export default "__VITE_ASSET__gJcD2J_h__"